import { AxiosPromise } from "axios";
import service from "../apis/Service";
import DtoSelectSearchTransportMode from "../models.machine/DtoSelectSearchTransportMode";
import RESTfulResult from "../models.machine/RESTfulResult";
import UiSelectOption from "../models.machine/UiSelectOption";
import DtoPageListSearchTransportMode from "../models.machine/DtoPageListSearchTransportMode";
import DtoPageListTransportMode from "../models.machine/DtoPageListTransportMode";
import UiDrag from "../models.machine/UiDrag";
import DtoDetailTransportMode from "../models.machine/DtoDetailTransportMode";
import DtoFormTransportMode from "../models.machine/DtoFormTransportMode";

/**
 * 海关运输方式
 * @description 自动生成的代码,请勿修改
 */
export default class TransportModeAppService {
    /**
     * 获取海关运输方式选择器
     * @param {DtoSelectSearchTransportMode} [search] 搜索条件
     * @returns {AxiosPromise<RESTfulResult<UiSelectOption<string>[]>>} 选择器
     */
    static GetSelect(search?: DtoSelectSearchTransportMode): AxiosPromise<RESTfulResult<UiSelectOption<string>[]>> {
        const url = `/api/TransportMode/GetSelect`;
        return service.get<RESTfulResult<UiSelectOption<string>[]>>(url, { params: search });
    }

    /**
     * 获取海关运输方式分页列表
     * @param {DtoPageListSearchTransportMode} [dto] 
     * @returns {AxiosPromise<RESTfulResult<DtoPageListTransportMode>>} 
     */
    static Get(dto?: DtoPageListSearchTransportMode): AxiosPromise<RESTfulResult<DtoPageListTransportMode>> {
        const url = `/api/TransportMode/Get`;
        return service.get<RESTfulResult<DtoPageListTransportMode>>(url, { params: dto });
    }

    /**
     * 拖曳排序
     * @param {UiDrag<string>} [dto] 传参
     * @returns {AxiosPromise<RESTfulResult<any>>} 
     */
    static DragSort(dto?: UiDrag<string>): AxiosPromise<RESTfulResult<any>> {
        const url = `/api/TransportMode/DragSort`;
        return service.post<RESTfulResult<any>>(url, dto);
    }

    /**
     * 获取海关运输方式详细
     * @param {string} [id] Id
     * @returns {AxiosPromise<RESTfulResult<DtoDetailTransportMode>>} 详细
     */
    static GetById(id?: string): AxiosPromise<RESTfulResult<DtoDetailTransportMode>> {
        const url = `/api/TransportMode/Get/${id}`;
        return service.get<RESTfulResult<DtoDetailTransportMode>>(url);
    }

    /**
     * 新增/编辑海关运输方式
     * @param {DtoFormTransportMode} [dto] 表单
     * @returns {AxiosPromise<RESTfulResult<any>>} 
     */
    static Post(dto?: DtoFormTransportMode): AxiosPromise<RESTfulResult<any>> {
        const url = `/api/TransportMode/Post`;
        return service.post<RESTfulResult<any>>(url, dto);
    }

    /**
     * 批量删除海关运输方式
     * @param {string[]} [ids] Id
     * @returns {AxiosPromise<RESTfulResult<any>>} 
     */
    static Delete(ids?: string[]): AxiosPromise<RESTfulResult<any>> {
        const url = `/api/TransportMode/Delete`;
        return service.delete<RESTfulResult<any>>(url, { data: ids });
    }

    /**
     * 导出
     * @param {string} [name] 
     * @param {string[]} [ids] 
     * @returns {AxiosPromise<RESTfulResult<string>>} 
     */
    static PostExportExceByName(name?: string, ids?: string[]): AxiosPromise<RESTfulResult<string>> {
        const url = `/api/TransportMode/PostExportExce/${name}`;
        return service.post<RESTfulResult<string>>(url, ids);
    }

    /**
     * 导出导入模板
     * @returns {AxiosPromise<RESTfulResult<string>>} 
     */
    static GetExportImportTemplate(): AxiosPromise<RESTfulResult<string>> {
        const url = `/api/TransportMode/GetExportImportTemplate`;
        return service.get<RESTfulResult<string>>(url);
    }

    /**
     * 导入
     * @param {any} [file] 
     * @returns {AxiosPromise<RESTfulResult<boolean>>} 
     */
    static PostImport(file?: any): AxiosPromise<RESTfulResult<boolean>> {
        const url = `/api/TransportMode/PostImport`;
        return service.post<RESTfulResult<boolean>>(url, file);
    }

    /**
     * 获取Name数组，用于重复判断
     * @returns {AxiosPromise<RESTfulResult<string[]>>} 
     */
    static GetNameList(): AxiosPromise<RESTfulResult<string[]>> {
        const url = `/api/TransportMode/GetNameList`;
        return service.get<RESTfulResult<string[]>>(url);
    }

}
